/* ============================================================
   nav-mobile.js — de panelen in de navigatielade.

   Eén niveau diep: tik op een item met een submenu en dat paneel schuift over
   het hoofdmenu, met de titel en een terugknop in de kop. Sluit je de lade, dan
   staat hij weer op het hoofdniveau — anders opent hij de volgende keer midden
   in een submenu waar je niets meer herkent.

   Toegankelijkheid (04-09-2026). Het paneel schuift óver het hoofdmenu heen
   (`.nav-mobile__submenu` is een laag met een dekkende achtergrond, thema.css
   r. 1773-1793). Voor het oog is het hoofdmenu dan weg; voor het toetsenbord
   niet — je tabde vanuit het submenu zo door naar de menu-items eronder, die
   niemand kon zien. De klasse `.is-verborgen` die dit script daarvoor zette
   bestaat in geen enkel CSS-bestand en deed dus niets.

   `inert` lost beide op: uit de tabvolgorde én uit de toegankelijkheidsboom,
   zonder iets aan de opmaak te veranderen. Wel op het juiste niveau — het
   submenu-paneel staat zelf ín de `<li>` in die lijst, en `inert` is erfelijk
   en niet terug te draaien op een kind. Dus niet de hele `<ul>`, maar: elke
   `<li>` behalve de geopende, plus in die geopende alleen de knop die het
   paneel opende (die zit óók onder de laag). De klasse `.is-verborgen` blijft
   er als haak voor het geval er later opmaak aan hangt; CSS heeft hij vandaag
   niet.
   ============================================================ */
(() => {
  const lade = document.querySelector('[data-drawer-navigation]');
  if (!lade) return;

  const boven = lade.querySelector('.js-header-top');
  const onder = lade.querySelector('.js-header-bottom');
  const titel = lade.querySelector('.js-nav-current');
  const terug = lade.querySelector('.js-nav-prev');
  const lijst = lade.querySelector('.js-nav-list');

  let laatsteOpener = null;

  const items = () => [...(lijst?.children || [])];

  const naarHoofd = () => {
    lade.querySelectorAll('.js-submenu').forEach((s) => { s.hidden = true; s.classList.remove('is-open'); });
    lade.querySelectorAll('.js-nav-submenu-open').forEach((k) => {
      k.setAttribute('aria-expanded', 'false');
      k.inert = false;
    });
    items().forEach((li) => { li.inert = false; });
    lijst?.classList.remove('is-verborgen');
    if (boven) boven.hidden = false;
    if (onder) onder.hidden = true;
    // Focus terug op de knop waarmee het submenu openging. Doe je dit niet, dan
    // valt de focus naar <body> zodra de terugknop verborgen wordt — en dan komt
    // Escape niet meer bij de lade aan en zit je erin vast zonder muis.
    // Let op de volgorde: eerst de lijst uit `inert` halen, dán focussen —
    // een element in een inerte tak neemt geen focus aan.
    laatsteOpener?.focus({ preventScroll: true });
  };

  lade.querySelectorAll('.js-nav-submenu-open').forEach((knop) => {
    knop.addEventListener('click', () => {
      const submenu = knop.parentElement.querySelector('.js-submenu');
      if (!submenu) return;
      submenu.hidden = false;
      submenu.classList.add('is-open');
      knop.setAttribute('aria-expanded', 'true');
      lijst?.classList.add('is-verborgen');
      if (titel) titel.textContent = knop.querySelector('span')?.textContent.trim() || '';
      if (boven) boven.hidden = true;
      if (onder) onder.hidden = false;
      laatsteOpener = knop;
      submenu.querySelector('a')?.focus({ preventScroll: true });
      // Pas ná het focussen inert zetten: de knop waarop je stond zit zelf in
      // de lijst, en zolang de focus daar nog vandaan moet mag de tak niet
      // inert zijn.
      const eigenItem = knop.closest('li');
      items().forEach((li) => { li.inert = li !== eigenItem; });
      knop.inert = true;
    });
  });

  terug?.addEventListener('click', naarHoofd);
  lade.addEventListener('dialoog:dicht', () => { laatsteOpener = null; naarHoofd(); });
})();
